import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import { useAuthStore, isAdmin } from '../stores/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Outil requis (id du registry). */
  tool?: string;
  adminOnly?: boolean;
}

/** Confort d'affichage uniquement : les droits sont appliqués par l'API. */
export default function ProtectedRoute({ children, tool, adminOnly }: ProtectedRouteProps) {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (status === 'loading') return <LinearProgress />;
  if (status === 'anonymous' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if ((adminOnly && !isAdmin(user)) || (tool && !user.tools.includes(tool))) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
